import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap"; 

import * as apiUrl from "../../apiUrl";

function MediaList() {
  const [MediaList, setMediaList] = useState({});

  useEffect(() => {
    const fetchMediaList = async () => {
      try {
        const response = await fetch(apiUrl.apiUrl + `/api/news/news-section`);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setMediaList(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchMediaList();
  }, []);
 
  const NewsContents = MediaList.news_content || [];

  return ( 
      <section className="media-list-sec">
        <Container fluid>
          <Row className="flex-center">
            {NewsContents.map((NewsContent, index) => (
              <Col md={4} key={index}>
                <div className="media-list-card" data-aos="fade-up">
                  <div className="media-list-img">                    
                      <img
                        src={`${apiUrl.apiUrl}/${NewsContent.image}`}
                        className="img-fluid"
                        alt="Buy property in Dubai"
                      />                    
                  </div>
                  <div className="media-list-content">
                    <h2 className="media-list-heading">
                      {NewsContent.news_title}
                    </h2>
                    <p className="media-list-para">
                      {" "}
                      - {NewsContent.publisher_name}
                    </p>

                    <div className="media-list-button-div">
                      <a
                        href={NewsContent.news_link} target={"_blank"}
                        className="marquis-roundededge-button"
                      >
                        Read More
                      </a>
                      <p className="media-list-para">
                        {NewsContent.date_place}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            ))}

         
          </Row>
        </Container>
      </section> 
  );
}

export default MediaList;
